import { InputLabel, TextField } from '@mui/material';
import styled from 'styled-components';

import { StyleTextInput } from './constant';

export const StyledTextField = styled(TextField)`
    ${StyleTextInput}
`;

export const StyledLabel = styled(InputLabel)``;
